import { gql } from "@apollo/client";

export const LOAD_ORGANIZATION_SPACES = gql`
  query LoadOrganizationSpaces($mrn: String!, $query: String, $first: Int) {
    organization(mrn: $mrn) {
      id
      spacesList(first: $first, query: $query) {
        edges {
          node {
            id
            mrn
            name
            description
          }
        }
      }
    }
  }
`;
